"use client";

import { useConsent } from "@/core/consent";

type CookieSettingsProps = {
  readonly label: string;
};

/**
 * Reopens the consent banner so a visitor can revisit a decision after it has
 * been dismissed. Being able to withdraw consent as easily as it was granted
 * is a CPRA requirement. Which CMP answers is the consent provider's concern,
 * not this link's; a click before the CMP has loaded is queued, never dropped.
 */
const CookieSettings = ({ label }: CookieSettingsProps) => {
  const { reopenBanner } = useConsent();

  return (
    <button
      // Matches the sibling FooterColumn links, with the pointer cursor and
      // focus ring a <button> does not inherit from them.
      className="type-body-sm text-champagne-white hover:text-amber cursor-pointer text-left transition-colors focus:outline-none focus-visible:ring-1 focus-visible:ring-white/30"
      onClick={reopenBanner}
      type="button"
    >
      {label}
    </button>
  );
};

export default CookieSettings;
